import React, {Fragment} from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {
  calculateAge, formatMoney, getMBAPremium,
  MBACoverageAmounts,
  rankList,
  traversePropertiesArray,
  traversePropertiesString
} from '../shared/shared';
import {getData} from "../../../api/doLogin";

export function Coverages(props) {
  const {values, handleCB, readonly, token, formFields} = props;

  function setFormFieldValue(field, value) {
    if (readonly) return;
    var objPost = {
      ...values,
      [field]: value,
    }
    handleCB(objPost);
  };

  function buildRank(branch) {
    let rankArray = rankList(branch) || [];
    return rankArray.map((value, index) => {
      return (
        <option key={index + 1} value={value}>{value}</option>
      );
    });
  }

  function getFormFieldValue(val) {
    if (val != null) {
      return val;
    } else {
      return "";
    }
  };

  function fetchZipDetails(zip, city, state) {
    if (readonly) return;
    if (zip.length === 0) {
      var objPost = {
        ...values,
        [city]: "",
        [state]: ""
      }
      handleCB(objPost);
      return;
    }
    getData("zip/get?zip=" + zip, {}, token)
      .then((data) => {
        if (data.status == "Success") {
          console.log(data.data);
          if (data.data.zipDetails.hasOwnProperty("city") && data.data.zipDetails.hasOwnProperty("state")) {
            var objPost = {
              ...values,
              [city]: data.data.zipDetails.city,
              [state]: data.data.zipDetails.state
            }
            handleCB(objPost);
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  function showMBAPremiumAmount(birthdate, useTobacco, coverage) {
    if (birthdate.replace("_", "").length >= 10 && coverage.length > 0) {
      return (
        <FormGroup>
          <Label htmlFor="monPremium">Monthly Premium</Label>
          <div>
            <strong>${formatMoney(getMBAPremium(calculateAge(birthdate), useTobacco, coverage))}</strong>
          </div>
        </FormGroup>
      )
    }
    return null;
  }

  return (
    <Fragment>
      <Row>
        <Col xs={"12"}>
          <h2>Coverage Information</h2>
        </Col>
      </Row>
      {traversePropertiesArray(formFields, ['basic', 'selectedApps']).length > 0 ?
        <Fragment>
          {traversePropertiesArray(formFields, ['basic', 'selectedApps']).indexOf("MBA") > -1 && (
            <Fragment>
              <Row>
                <Col xs={"2"}>
                  <h5>MBA{traversePropertiesString(formFields, ['basic', 'relationshipStatus']) === "M" ? " Primary" : ""}</h5>
                </Col>
                <Col xs={2}>
                  <FormGroup>
                    <Label htmlFor="mbaCoverage">Coverage&nbsp;Amount*</Label>
                    <Input type="select" name="mbaCoverage" id="mbaCoverage"
                           value={getFormFieldValue(values.mbaCoverage)}
                           onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
                      <option key={0} value={""} disabled={true}>Choose</option>
                      {MBACoverageAmounts.map((coverage, index) => {
                        return (
                          <option key={index + 1} value={coverage.value}>{coverage.label}</option>
                        )
                      })}
                    </Input>
                  </FormGroup>
                </Col>
                <Col xs={2}>
                  {showMBAPremiumAmount(traversePropertiesString(formFields, ['primary', 'bdate']), traversePropertiesString(formFields, ['primary', 'tobacco']) === "Y", getFormFieldValue(values.mbaCoverage))}
                </Col>
              </Row>
              {traversePropertiesString(formFields, ['basic', 'relationshipStatus']) === "M" && (
                <Row>
                  <Col xs={"2"}>
                    <h5>MBA Spouse</h5>
                  </Col>
                  <Col xs={2}>
                    <FormGroup>
                      <Label htmlFor="mbaSpouseCoverage">Coverage&nbsp;Amount*</Label>
                      <Input type="select" name="mbaSpouseCoverage" id="mbaSpouseCoverage"
                             value={getFormFieldValue(values.mbaSpouseCoverage)}
                             onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
                        <option key={0} value={""} disabled={true}>Choose</option>
                        {MBACoverageAmounts.map((coverage, index) => {
                          return (
                            <option key={index + 1} value={coverage.value}>{coverage.label}</option>
                          )
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col xs={2}>
                    {showMBAPremiumAmount(traversePropertiesString(formFields, ['spouse', 'bdate']), traversePropertiesString(formFields, ['spouse', 'tobacco']) === "Y", getFormFieldValue(values.mbaSpouseCoverage))}
                  </Col>
                </Row>
              )}
            </Fragment>
          )}
        </Fragment>
        :
        <Row>
          <Col xs={"12"}>
            <h5>Choose an application first from the Basic Info section</h5>
          </Col>
        </Row>
      }

    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/containers/Applications/sections/Coverages.js